import { db } from './firebase';
import { collection, query, getDocs, orderBy } from 'firebase/firestore';
import { AuditLog } from '../types/audit';

/**
 * Listar registros de auditoría (Directo a Firestore)
 */
export async function listLogs(params: { limit?: number; offset?: number } = {}) {
    try {
        const limitVal = params.limit || 50;
        const offsetVal = params.offset || 0;

        const q = query(
            collection(db, 'audit_logs'),
            orderBy('createdAt', 'desc')
        );

        const snapshot = await getDocs(q);
        const allLogs = snapshot.docs.map(doc => ({ logId: doc.id, ...doc.data() } as AuditLog));

        // Simular paginación en memoria
        const logs = allLogs.slice(offsetVal, offsetVal + limitVal);

        return {
            success: true,
            logs,
            pagination: {
                total: allLogs.length,
                limit: limitVal,
                offset: offsetVal,
                hasMore: offsetVal + limitVal < allLogs.length
            }
        };
    } catch (error) {
        console.error("Error listing audit logs:", error);
        return {
            success: false,
            logs: [],
            pagination: { total: 0, limit: 50, offset: 0, hasMore: false }
        };
    }
}

export const auditService = {
    listLogs
};
